import { loadLocalState } from "../local-storage";
import { loadSessionState } from "../session-storage";

export const getStoreType = (typeStore: string) => {
    switch (typeStore) {
        case "session":
            return loadSessionState();
        case "local":
            return loadLocalState();
        case "redux":
            return {};
        default:
            return {};
    }
};
